import {Pipe, PipeTransform} from '@angular/core';

const /** @type {?} */ escape = s => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
export class HighlightPipe implements PipeTransform {
/**
 * \@name transform
 * @param {?} value {string}
 * @param {?} arg {string}
 * @return {?}
 */
public transform(value: string, arg: string): string {
        if (!arg.trim()) {
            return value;
        }

        try {
            const /** @type {?} */ regex = new RegExp(`(${escape(arg)})`, 'i');
            return value.replace(regex, '<b>$1</b>');
        } catch ( /** @type {?} */e) {
            return value;
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
    name: 'highlight'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HighlightPipe_tsickle_Closure_declarations() {
/** @type {?} */
HighlightPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HighlightPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
